module.exports = __webpack_public_path__ + "media/images/game/pages/logo_kapodav-94d565721867f3f0c35a764982068877.png";